import { gql } from "@apollo/client";
import JobFields from "../fragments/job-fragment";

export default gql`
query getEditableJob($id: ID!) {
  job(id: $id) {
    ...JobFields
    id
    start
    end
    startUtc
    endUtc
    timezone
    workTypeId
    peopleNeeded
    breakMins
    paidBreakMins
    street
    city
    region
    unit
    floor
    locationInstruction
    latitude
    longitude
    description
    isPrivate
    tags
    gears
    skills
    manager{
      id
      firstName
      lastName
      isActive
    }
    jobManager{
      id
      role
      managerId
      manager{
        id
        firstName
        lastName
        isActive
      }
    }
    employer {
      billingRate
      city
      companyName
      country
      email
      firstName
      lastName
      id
      mobilePhone
      payRate
      region
      street
      logoImageUrl
      signedLogoImageUrl
      latitude
      longitude
      canPostPrivateJob
    }
    positions {
      worker {
        id
        firstName
        lastName
        profileImageUrl
        signedProfileImageUrl
        vaccinationStatus
      }
    }
}
}
${JobFields}
`;
